import { useMatch } from 'react-router-dom'

export const usePathMatch = () => {
  const match = useMatch('/pass_change')
  const match2 = useMatch('/change-password')
  
  return !!(match || match2)
}
